import { render, staticRenderFns } from "./OutputFormat.vue?vue&type=template&id=e8d827b0&"
import script from "./OutputFormat.vue?vue&type=script&lang=js&"
export * from "./OutputFormat.vue?vue&type=script&lang=js&"
import style0 from "./OutputFormat.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports